"use client";

import { TitleH2 } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { floorPlanDesignLogo } from "../../../../public/images/floor-plan-designs";

const AdditionalOption = () => {
  const tC = useTranslations("common");
  const tH = useTranslations("floorPlanDesigns.additionalOpt");

  return (
    <div className="bg-secondary">
      <div className="gs--page-column py-16">
        <div className="flex flex-col items-center gap-10 min-[900px]:flex-row min-[900px]:items-start">
          <div className="flex flex-col gap-5">
            <TitleH2 title={tH("title")} />
            <p className="text-ring">{tH("text")}</p>
            <p className="text-ring">{tH("text2")}</p>

            <div className="flex items-center max-sm:justify-between min-sm:gap-50">
              <ul className="flex flex-col gap-2 font-medium">
                <li className="text-ring">{tC("northArrow")}</li>
                <li className="text-ring">{tC("scale")}</li>
                <li className="text-ring">{tC("entranceArrow")}</li>
                <li className="text-ring">{tC("watermark")}</li>
              </ul>

              <ul className="flex flex-col gap-2 font-medium">
                <li className="text-ring">{tC("yourLogo")}</li>
                <li className="text-ring">{tC("textBlocks")}</li>
                <li className="text-ring">{tC("floor")}</li>
                <li className="text-ring">{tC("legalNotice")}</li>
              </ul>
            </div>
          </div>

          <Image
            src={floorPlanDesignLogo}
            alt={"Grundriss Design mit Wasserzeichen"}
            width={380}
            height={380}
            className="border"
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalOption;
